export const FunnelWebsiteRouteNames = {
  clientPortal: {
    dashboard: 'clientportal-dashboard',
    domainSetup: 'clientportal-domain-setup',
    branding: 'branding',
    appPermission: 'app-permission',
    brandedApp: 'branded-app',
    settings: 'clientportal-settings',
    emailSettings:'email-settings',
    languageSettings:'language-settings',
    chatWidget: 'chat-widget-settings',

  },
  funnels: {
    default: 'funnels-v2',
    funnelsPage: 'funnels-page-v2',
    funnelsWebsite: 'websites-funnels-v2',
    funnelsStore: 'stores-funnels-v2',
    funnelsWebinar: 'webinars-funnels-v2',
  },
  funnelsDetails: {
    default: 'funnels-detail-v2',
    steps: 'funnel-steps-v2',
    stepOverview: 'funnel-step-overview-v2',
    stepAutomation: 'funnel-step-automation-v2',
    stepPublish: 'funnel-step-publish-v2',
    stepProduct: 'funnel-step-product-v2',
    stepProducts: 'funnel-step-products-v2',
    stepProductCreate: 'funnel-step-product-v2-create',
    stepProductEdit: 'funnel-step-product-v2-edit',
    stats: 'funnel-stats-v2',
    sales: 'funnel-sales-v2',
    settings: 'funnel-settings-v2',
    security: 'funnel-security-v2',
    events: 'funnel-events-v2',
  },
  funnelTemplateCategory: 'funnel-templates-category',
  funnelTemplateCatDetail: 'funnel-templates-category-detail',
  funnelTemplateDetail: 'funnel-templates-detail',
  funnelWebsites: {
    default: 'websites-detail-v2',
    pages: 'website-pages-v2',
    stats: 'website-stats-v2',
    sales: 'website-sales-v2',
    settings: 'website-settings-v2',
    security: 'website-security-v2',
    events: 'website-events-v2',
    products: 'website-products-v2',
    stepProduct: 'website-step-products-v2',
    stepProductCreate: 'website-step-product-v2',
    stepProductEdit: 'website-step-product-v2-edit',
  },
  funnelStores: {
    default: 'stores-detail-v2',
    pages: 'store-pages-v2',
    productSelect: 'store-product-select-v2',
    stats: 'store-stats-v2',
    sales: 'store-sales-v2',
    settings: 'store-settings-v2',
    security: 'store-security-v2',
    events: 'store-events-v2',
    products: 'store-products-v2',
    stepProduct: 'store-step-products-v2',
    stepProductCreate: 'store-step-product-v2',
    stepProductEdit: 'store-step-product-v2-edit',
  },
  webinars: {
    default: 'webinars-detail-v2',
    pages: 'webinar-pages-v2',
    stats: 'webinar-stats-v2',
    sales: 'webinar-sales-v2',
    settings: 'webinar-settings-v2',
    security: 'webinar-security-v2',
    events: 'webinar-events-v2',
    products: 'webinar-products-v2',
    stepProduct: 'webinar-step-products-v2',
    stepProductCreate: 'webinar-step-product-v2',
    stepProductEdit: 'webinar-step-product-v2-edit',
  },
  websiteTemplatesCategory: 'website-templates-category',
  websiteTemplatesCategoryDetail: 'website-templates-category-detail',
  websiteTemplatesDetail: 'website-templates-detail',
  wordpress: {
    default: 'wordpress-v2',
    dashboard: 'wordpress_dashboard-v2',
    advance: 'wordpress_advance-v2',
    userManagement: 'wordpress_user_management-v2',
    pluginManagement: 'wordpress_plugin_management-v2',
    themeManagement: 'wordpress_theme_management-v2',
    backupManagement: 'wordpress_backup_management-v2',
    analyticsReport: 'wordpress_analytics_report-v2',
  },
  jotBoxForm: 'jotbox_form-v2',
  jotBoxSurvey: 'jotbox_survey-v2',
  formBuilderManageOld: 'form_builder_manage_old-v2',
  chatWidgetSettings: 'chat-widget-settings-v2',
  chatWidget: 'chat-widget',
  editChatWidget: 'edit-chat-widget',
}
